import type { AttributeExpressionOption } from 'shared-types';

interface Params {
  expression: AttributeExpressionOption | 'undefined';
  reference: string[] | string | number | boolean;
  userValue: string[] | boolean | number | string;
}

const matchOnExpression = ({
  expression,
  reference,
  userValue
}: Params): boolean => {
  // safeguard for existing cases where expression will be undefined
  if (expression === 'undefined') {
    expression = Array.isArray(reference) ? 'includes' : 'equals';
  }

  if (expression === 'equals') return userValue === reference;

  if (
    expression !== 'empty' &&
    expression !== 'not equals' &&
    expression !== 'not includes' &&
    !userValue
  )
    return false;

  if (expression === 'not equals') return userValue !== reference;
  else if (expression === 'is one of')
    return Array.isArray(reference) && typeof userValue === 'string'
      ? reference.includes(userValue)
      : false;
  else if (expression === 'includes') {
    return Array.isArray(userValue) || typeof userValue === 'string'
      ? userValue.includes(reference as string)
      : false;
  } else if (expression === 'not includes') {
    return Array.isArray(userValue) || typeof userValue === 'string'
      ? !userValue.includes(reference as string)
      : false;
  } else if (expression === 'includes one of') {
    return Array.isArray(reference) && Array.isArray(userValue)
      ? reference.some((referenceItem) => userValue.includes(referenceItem))
      : false;
  } else if (expression === 'greater') return userValue > reference;
  else if (expression === 'lesser') return userValue < reference;
  else if (expression === 'any') return Boolean(userValue);
  else if (expression === 'empty')
    return !userValue || !(userValue as string[])?.length;
  else return false;
};

export default matchOnExpression;
